export { registerComponent as registerFormComponent } from '../../components/builtin/Form/register'
export { default as Form } from '../../components/builtin/Form/Form'
